export default {
	payMoney: 'Pay Money',
	CostName: 'Item',
	UnitPrice: 'Unit Price',
	number: 'number',
	Subtotal: 'Subtotal',
	Deposit: 'Deposit',
	isDeposit: 'is deposit',
	writeAnInvoice: 'write an invoice',
	operation: 'operation',
	remark: 'remark',
	totalOfCostToBePaid: 'Total of Cost to be paid',
	totalOfCommodityrentalfees: 'Total of Commodity rental fees',
	totalOfFixedCost: 'Total of Fixed cost',
	delete: 'delete',
	addRemarks: 'Add remarks',
	Nameofpersonincharge: 'Contact Information',
	Contactnumber: 'Contact person',
	ChoosePayment: 'Choose payment',
	feeSuccessful: 'Successful payment',
	OfflineRemittance: 'Offline remittance',
	'深圳市纸制品展览会': 'Shenzhen Paper Products Exhibition',
	'布展时间': 'Distribution time',
	'至': 'to',
	'开展时间': 'Development time',
	'待缴费用': 'Expenses to be paid',
	'共': ' total ',
	'个展位费用': 'booths,',
	'个展位': 'booths, Rental Fees of',
	'项费用': 'Cost',
	'展位': 'Booth No',
	'搭建商':'Builder',
	'删除': 'delete',
	'商品租赁': 'Rent Goods',
	'项租赁费用': 'items',
	'现场负责人': 'Person in Charge of the Site',
	'请输入负责人姓名': 'Please enter the name of the person in charge.',
	'请输入正确的手机号码': 'Please enter mobile phone number.',
	'请输入联系方式': 'Please enter your contact information.',
	'请填写贵展位的现场负责人，对于订单的配送及异常状况的处理，我们的工作人员将联系该负责人，请如实填写，如因无法联系或者联系方式错误等原因造成的订单服务时效过长，我司概不负责': "Please fill in the Person in Charge of the Site. Our staff will contact the person in charge for goods delivery and in case situation of an emergency. Please give us the valid phone because we will not be responsible for overtime delivery and service due to the invalid contact number.",
	'订单总计': 'Order Amount',
	'元': 'RMB',
	'上一步': 'Previous',
	'提交订单': 'Submit Order',
	'添加备注': 'Add notes',
	'请输入备注': 'Please enter notes...',
	'参展商':'Exhibitor',
	'填写并核对订单信息':'Fill in and check the order information',


	//feePayment
	'订单列表': 'Order List',
	'订单号': 'Order number',
	'联系方式': 'Contact information',
  '支付方式':'Payment method ',
	'微信支付': 'Wechat Payment',
	'支付宝支付': 'Alipay payment',
	'线下汇款': 'Offline payment',
  '云账单支付': 'CloudBill payment',
	'如需公账付款，请选择支付宝或转账汇款': '',
	'如需公账付款，请选择支付宝': '',
	//'If payment is required, please choose Alipay or Internet banking payment.',
	'不会支付宝公帐汇款？': '',
	//'No Alipay public remittance?',
	'确认支付': 'Confirmation of payment',
  '提示':'Prompt',
  '提示内容':'A deposit must be paid first before proceeding with payment of the merchandise cost.',
  '提交订单':'Place an order',
  '押金支付':'Deposit payment',
  '费用支付':'Payment of costs',
  '支付成功':'Payment successful',
  '押金订单':'Order Type：Deposit Order',
  '费用订单':'Order Type：Expense Order',
  '请选择支付方式':'Please select payment method！',
	'请在': 'Please pay in',
	'分': 'minute ',
	'秒内支付完成': 'seconds',
	'支付方式选择提示':'Payment options prompt',
	'您选择通过':'You choose to pass ',
	'进行支付':'Payment，Payment will not be changed after confirmation. Please confirm.',
	'支付方式已选择':'Payment method has been selected!',
	'返回订单中心':'Return to order center',
	'支付失败':'Failure to pay',
	'网络出错':'Network error, please try again',
	'待支付': 'UNPAID',
	'已退款': 'REFUNDED',
	'已取消': 'CANCELED',
	'已完成': 'COMPLETED',
	'已失效': 'FINISH',
	'已出保单': 'ISSUEBILL',
	'出单失败': 'POLICY_FAIL',
	'已退保': 'SURRENDERED',
	'支付订单':'Payment order',
	'联系人姓名':'Contact Name',
	'联系电话':'Contact number',
	'订单详情':'Order details',
	'展位号':'Booth number',
	'金额':'Amount of money',
	'状态':'state',
	'创建时间':'Creation time',
	'名称':'Name',
	'订单提交成功':'Successful submission of orders',
	'共生成':'Generate',
	'笔订单':'total order',
	'请尽快付款':'Please pay as soon as possible',
	'您已选择支付方式或订单已支付，请勿重复提交！':'You have selected the payment method or the order has been paid, please do not submit it again!',
	'查看订单详情':'View order details',

	//feeSuccessful
	'支付成功':'Successful payment',
	'秒后将为您跳转到':' seconds later, you will jump to ',
	'订单中心':'Order Center',
	'返回':'back',
	'信息':'information',
	'确定删除该费用吗':'Are you sure you want to delete the fee?',
	'网络出错':'Network error, please try again!',
	'提交失败':'Submission failure',
	'订单为空':'The order is empty and cannot be submitted.',
	'确定':'Determine',
	'取消':'cancel',
	'返回修改租赁商品':'Return to modify leased goods',
	'返回展位费用选择':'Return to booth fee selection',
	'联系电话':'Contact number',
	'联系人信息':'Contact Information',
	'请输入备注':'Please Enter Remarks'
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/feeConfirmation.js